import React from 'react'
import get from 'lodash/get'
import { ResourceUtilButton } from './resource-utilization'

export default class ButtonGroup extends React.Component {
  render() {
    const overviewTab = get(this.props, 'overviewTab')
    switch (overviewTab) {
      case 2: return (
        <ResourceUtilButton
          exportEfficiencyLOB={ get(this.props, 'exportEfficiencyLOB') }
          handleSearchResource={ get(this.props, 'handleSearchResource') }
        />
      )
      default: return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-overview/detail/tab/button-group/index.js